import { React } from 'react'
import { Link, useLocation } from 'react-router-dom'
import CustomIcon from 'components/Icon'
import Icon from 'icons/Icon'
import { formatTags, getGameUrl, isNewGame } from 'utils/helpers'
import { useSelector } from 'react-redux'
import { getItem } from 'utils/storageUtils'
import RestrictedOverlay from '../RestrictedOverlay'
import './styles/index.scss'
import { getProcessedProviderName } from '../../../utils/provider'

const GameCardV1 = ({
  game,
  index,
  toggleFavorite,
  selectedLanguageCode,
  playGameCallback,
  isLabeled,
  labelIconUrl,
  favoriteGamesList
}) => {
  const { brandLogo } = useSelector(state => state.language)
  const loggedIn = JSON.parse(getItem('loggedIn'))
  const { languageData } = useSelector((state) => state.language)
  const { gameFilterSupportType } = useSelector((state) => state.uiConfig.general) || {}
  const location = useLocation()

  const CardDetails = ({ langKey, value, icon }) => (
    <div className='lobby-game-otherinfo'>
      <div className='lobby-game-otherinfo-label'>
        <Icon name={`${icon}-solid`} width='14' height='14' className='mr-1' />
        {langKey}
      </div>
      <div className='lobby-game-otherinfo-value'>{value}</div>
    </div>
  )

  const processedProviderName = getProcessedProviderName(game, gameFilterSupportType)


  return (
    <div key={`list-menu-item-${index}`} className='lobby-game-card'>
      <div className='game-container'>
        <div className='hover-area'>
          {game?.restrictedGame
            ? <RestrictedOverlay />
            : (
              <div className='hover-content'>
                <div
                  className='fav-icon'
                  onClick={(e) => {
                    e.preventDefault()
                    toggleFavorite({
                      isFavorite: favoriteGamesList?.rows?.some((el) => el.id === game?.id),
                      id: game?.id,
                      subCategoryId: +game?.subCategoryId
                    })
                  }}
                >
                  <CustomIcon
                    name='favorite'
                    fill={favoriteGamesList?.rows?.some((el) => el.id === game?.id) ? '#ffffff' : ''} />
                </div>
                <br />
                <span className='hover-content-buttons'>
                  <Link
                    className='real-play'
                    to={getGameUrl(selectedLanguageCode?.toLowerCase(), game?.gameId, game?.name, game?.providerName)}
                    onClick={() => {
                      if (location?.pathname) {
                        window.previousScreen = location.pathname
                      }
                      if (playGameCallback) playGameCallback()
                    }}
                  >
                    Play
                    <Icon name='play-solid' width='14' height='14' />
                  </Link>
                  {game?.demo && window.innerWidth > 1024 && !loggedIn && (
                    <Link
                      className='demo-play'
                      to={getGameUrl(selectedLanguageCode?.toLowerCase(), game?.gameId, game?.name, game?.providerName, true)}
                      onClick={() => {
                        if (location?.pathname) {
                          window.previousScreen = location.pathname
                        }
                        if (playGameCallback) playGameCallback()
                      }}
                    >
                      {languageData?.tryForFree}
                    </Link>
                  )}
                </span>
              </div>
              )}
          <img
            loading='lazy'
            src={game?.thumbnailUrl || game?.gameThumbnailUrl || languageData?.gameCardPlaceholderImage || '/images/placeholder.svg'}
            onError={(e) => {
              e.target.onerror = null
              e.target.src = languageData?.gameCardPlaceholderImage || '/images/placeholder.svg'
            }}
            className='w-100 game-img'
            alt='game'
          />
        </div>
        {(isNewGame(game?.moreDetails?.released_at) || !!isLabeled) && (
          <div className='game-tag-wrapper'>
            <div className='game-tag new'>
              {(!!isLabeled && !!labelIconUrl) ? <img src={labelIconUrl} alt='Icon' /> : <Icon name='sparkles' width='14' height='14' />}
            </div>
          </div>
        )}
        <div className='lobby-game-info'>
          <div className='lobby-game-name'>{game?.name}</div>
          <div className='lobby-game-studio'>
            <img
              src={game?.studioLogo || game?.providerLogo || brandLogo || '/images/brand-logo.svg'}
              onError={(e) => {
                e.target.onerror = null
                e.target.src = brandLogo || '/images/brand-logo.svg'
              }}
              className='lobby-game-studio-logo'
              alt='studio'
            />
            <span className='lobby-game-studio-name'>
              {processedProviderName}
            </span>
          </div>
          {game?.volatilityRating
            ? (
              <CardDetails
                langKey={languageData?.volatility}
                value={game?.volatilityRating}
                icon='chart-line-up-down'
              />
              )
            : (formatTags(game?.theme) === '-' && game?.returnToPlayer)
                ? (
                  <CardDetails
                    langKey={languageData?.returnToPlayer}
                    value={game?.returnToPlayer + '%'}
                    icon='coins'
                  />
                  )
                : (
                  <CardDetails
                    langKey={languageData?.theme}
                    value={formatTags(game?.theme)}
                    icon='palette'
                  />
                  )}
        </div>
      </div>
    </div>
  )
}

export default GameCardV1
